import { useMemo } from "react";
import Card from "components/card";
import EnhancedTable from "../../overview/summarytable/SummaryTable";
import { usePortfolioData } from "contexts/PortfolioContext";

const PortfolioBuildingSummary = () => {
    const {
        currentPortfolio,
        selectedPeriod,
        currentPortfolioFacility,
        currentPortfolioName,
        currentGroup,
    } = usePortfolioData();

    const overrideData = useMemo(() => ({
        currentDeal: currentPortfolio,
        selectedPeriod,
        currentFacility: currentPortfolioFacility,
        currentDealName: currentPortfolioName,
    }), [currentPortfolio, selectedPeriod, currentPortfolioFacility, currentPortfolioName]);

    return (
        <Card extra={"items-center justify-around w-full h-full p-[16px] bg-cover gap-2 flex flex-col"}>
            <h3 className="ml-6 mb-2 text-xl self-start font-bold text-gray-700 dark:text-white">Facilities Summary</h3>
            <EnhancedTable overrideData={overrideData} selectedGroup={currentGroup} />
        </Card>
    );
};

export default PortfolioBuildingSummary;
